"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFilter = useFilter;
var _react = _interopRequireWildcard(require("react"));
var _ChartFilter = _interopRequireDefault(require("../components/ChartFilter"));
var _chartOperations = require("../utils/chart-operations");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function useFilter(_ref) {
  let {
    chart,
    theme,
    layout,
    parentFilter
  } = _ref;
  const getDefaultFilter = (0, _react.useCallback)(() => {
    let defaultFilter = null;
    if (chart.filterCol) {
      const labels = (0, _chartOperations.getColumnLabels)(chart.dataView.data, chart.filterCol, chart.dataView.columns);
      if (labels.length > 0) {
        defaultFilter = labels[0].key;
      }
      if (chart.filterDisplay === "parent" && chart.filterCol in parentFilter) {
        defaultFilter = parentFilter[chart.filterCol];
      }
    }
    return defaultFilter;
  }, [chart, parentFilter]);
  const [filter, setFilter] = (0, _react.useState)(getDefaultFilter());
  (0, _react.useEffect)(() => {
    const defaultFilter = getDefaultFilter();
    if (defaultFilter !== filter) {
      setFilter(defaultFilter);
    }
  }, [chart.filterCol, getDefaultFilter]);
  const filterComponent = /*#__PURE__*/_react.default.createElement(_ChartFilter.default, {
    chart: chart,
    onChange: setFilter,
    filterValue: filter,
    theme: theme,
    layout: layout
  });
  return {
    filter,
    filterComponent
  };
}